<script lang="ts" setup>
import { computed } from 'vue'

/**
 * Badge de estado con punto de color: Publicada (verde), Borrador (ambar),
 * Activa (verde), Inactiva (gris).
 */
const props = defineProps<{
  color: 'green' | 'yellow' | 'gray' | 'blue'
  label: string
}>()

const classes = computed(() => {
  switch (props.color) {
    case 'green':
      return 'bg-green-50 text-green-600'
    case 'yellow':
      return 'bg-yellow-50 text-yellow-600'
    case 'blue':
      return 'bg-blue-50 text-blue-600'
    default:
      return 'bg-gray-100 text-gray-500'
  }
})

const dotClasses = computed(() => {
  switch (props.color) {
    case 'green':
      return 'bg-green-500'
    case 'yellow':
      return 'bg-yellow-400'
    case 'blue':
      return 'bg-blue-500'
    default:
      return 'bg-gray-400'
  }
})
</script>
<template>
  <span
    class="inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-2.5 py-1 whitespace-nowrap"
    :class="classes">
    <span class="w-1.5 h-1.5 rounded-full shrink-0" :class="dotClasses" />
    {{ label }}
  </span>
</template>
